const PDF_SIGNATURE = '%PDF-';

const getFileTypeFromHeader = async file => {
  const header = await file.slice(0, PDF_SIGNATURE.length).arrayBuffer();
  return new TextDecoder().decode(header) === PDF_SIGNATURE ? 'application/pdf' : '';
};

/**
 * Creates a browser preview URL with a reliable content type and image dimensions.
 * PDF files are identified from their signature when the server provides an
 * incorrect or missing MIME type.
 */
export const createFilePreview = async (file, fallbackType = '') => {
  const declaredType = (file.type || fallbackType || '').toLowerCase();
  const hasKnownPreviewType =
    declaredType === 'application/pdf' || declaredType.startsWith('image/');
  const detectedType = hasKnownPreviewType ? '' : await getFileTypeFromHeader(file);
  let type = detectedType || declaredType;
  let previewFile = type && type !== file.type ? new Blob([file], { type }) : file;
  let width;
  let height;

  if (type !== 'application/pdf' && typeof createImageBitmap === 'function') {
    try {
      const bitmap = await createImageBitmap(previewFile);
      type = type.startsWith('image/') ? type : 'image/*';
      width = bitmap.width;
      height = bitmap.height;
      bitmap.close();
      previewFile = new Blob([file], { type });
    } catch (_error) {
      // Non-image files, such as PDFs, use the iframe preview path.
    }
  }

  return {
    url: URL.createObjectURL(previewFile),
    type,
    ...(width && height ? { width, height } : {}),
  };
};
